// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__jE8nr","gfeWrapper":"CalendarEvent_gfeWrapper__1Phh_"};